import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledLegendWrapper = styled.span`
    width: 100%;
    margin-bottom: 8px;

    .winnerIcon {
        padding-top: 0;
    }
`;

export const LegendsContainer = styled.div`
    padding-top: 8px;
    width: 240px;
    &.separatorLine {
        ${StyledLegendWrapper} {
            &:last-child {
                margin-top: 12px;
                padding-top: 20px;
                border-top: 1px solid ${colorsPalettes.carbon[100]};
            }
        }
    }
`;

